import { PrensaEngine } from '@xprog/prensa'
import { PrensaEngineCSSProp } from '@xprog/prensa/types'

export const CloseProps: PrensaEngineCSSProp = {
  color: '#959595',
  cursor: 'pointer',
  fontSize: '14px',
  lineHeight: '20px',
  fontFamily: '$primary',
  my: '$0'
}

export const TitleOpenProps: PrensaEngineCSSProp = {
  color: '#9A9A9A',
  cursor: 'pointer',
  fontFamily: '$primary',
  fontSize: '18px',
  fontWeight: 400,
  letterSpacing: '0.2px',
  lineHeight: '23px',
  my: '$0',
  display: 'none',
  '@lg': {
    display: 'flex'
  }
}

export const SubjectProps: PrensaEngineCSSProp = {
  color: '$basicWhite',
  fontSize: '14px',
  fontFamily: '$primary',
  fontWeight: 700,
  letterSpacing: '0.2px',
  lineHeight: '21px',
  pl: '$4',
  ml: '$0',
  mt: '$0',
  mb: '$2',
  '&::before': {
    content: '',
    backgroundColor: '#F06C6C',
    borderRadius: '50%',
    color: '#F06C6C',
    fontSize: '$2',
    lineHeight: '$2',
    height: '$2',
    width: '$2',
    ml: '-$4',
    mt: '6px',
    position: 'absolute'
  },
  '@lg': {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 500,
    textTransform: 'uppercase'
  }
}

export const TitleProps: PrensaEngineCSSProp = {
  color: '$basicWhite',
  cursor: 'pointer',
  fontSize: '14px',
  fontFamily: '$primary',
  fontWeight: 400,
  letterSpacing: '0.2px',
  lineHeight: '17px',
  ml: '$0',
  mb: '$4',
  my: '$0',
  '@lg': {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 500
  }
}

export const TitlePropsExpanded: PrensaEngineCSSProp = {
  ...TitleProps,
  fontSize: '14px',
  lineHeight: '17px',
  '@lg': {
    my: '$4',
    fontSize: '20px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    lineHeight: '24px'
  }
}

export const EmbedCode = PrensaEngine.styled('div', {
  align: ['column', 'left', 'top'],
  marginBottom: '$2',
  width: '100%',
  iframe: {
    mb: '$2 !important'
  }
})

export const Thumbnail = PrensaEngine.styled('img', {
  align: ['column', 'left', 'top'],
  marginBottom: '$0',
  width: '25%',
  '@lg': {
    height: '100px',
    width: '200px'
  }
})
